import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-news',
    templateUrl: './news.component.html',
    styles: [],
    standalone: false
})
export class NewsComponent implements OnInit {
  ngOnInit(): void {}
}
